var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dd-button',{attrs:{"size":_vm.size,"color":_vm.ColorAssistant.ProjectColor,"new-icon":""},on:{"click":function($event){return _vm.handleClick()}}},[_c('i',{staticClass:"ddi ddi-task"}),_vm._v(" "),_c('span',[_vm._v("New Task")])])}
var staticRenderFns = []

export { render, staticRenderFns }